/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { SaleZone } from './saleZone';

export class SaleRate extends DaoModel {
  constructor(guid, name, is_managed, sale_zones) {
    super(guid);
    this.name = name || '';
    this.is_managed = is_managed || false;
    this.sale_zones = sale_zones || [];
  }

  static toInstance(props = {}) {
    const sale_zones = SaleZone.toInstanceList(props.sale_zones);
    return new SaleRate(props.guid, props.name, props.is_managed, sale_zones);
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
      is_managed: this.is_managed,
      sale_zones: this.sale_zones.map((zone) => zone.serialize()),
    };
  }

  get saleZoneNames() {
    return this.sale_zones.map((zone) => zone.name).join('/');
  }
}
